import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = loc.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/auth"); return; }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        localStorage.setItem("brunchi_token", data.token);
        setSession(data.user);
        toast.success(`Welcome, ${data.user.name?.split(" ")[0] || ""}!`);
        window.history.replaceState({}, "", "/");
        const next = sessionStorage.getItem("brunchi_auth_next");
        sessionStorage.removeItem("brunchi_auth_next");
        const target = next && next.startsWith("/")
          ? next
          : (data.user.is_admin ? "/admin" : "/account");
        nav(target, { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        nav("/auth", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="auth-callback-page">
      <div className="font-serif text-2xl">Signing you in…</div>
      <p className="text-sm text-[color:var(--brunchi-ink-soft)] mt-2">One moment while we secure your session.</p>
    </div>
  );
}
